export const ROUTES = {
  LANDING: '/landing',
  MERCHANT: '/',
  MERCHANT_LOGIN: '/login',
  MERCHANT_DATA_PASS: '/data-pass',
  MERCHANT_OFFERS_LIST: '/offers',
  MERCHANT_DATA_PASS_TERMINAL: '/data-pass/:dataPassId',
  MERCHANT_SCANNER: '/data-pass/:dataPassId/scanner',
  MERCHANT_SET_PASSWORD: '/verify-email/:verifyToken',
  MERCHANT_RESET_PASSWORD: '/reset-password/:resetToken',
  MERCHANT_RECOVER_PASSWORD: '/recover-password',
  MERCHANT_PAYMENTS: '/payments',
  MERCHANT_SIGNUP: '/signup',
  MERCHANT_CREATE_PROFILE: '/profile/create',
  MERCHANT_ORDER_RESPONSE: '/order/complete',
  MERCHANT_CUSTOMER_SIGNUP: '/customer/signup',
  AUTH_CALLBACK: '/auth/callback',
};
